const formatId = (partNumber, revision) => {
  if (revision === '-') return partNumber
  return `${partNumber}+${revision}`
}

export const formatIdAttribute = (item) => {
  if (!item) return null

  const { partNumber, revision } = item
  return formatId(partNumber, revision)
}

export const formatIdAttributeImm = (item) => {
  if (!item) return null

  const partNumber = item.get('partNumber')
  const revision = item.get('revision')

  return formatId(partNumber, revision)
}
